export default {
    divisionList: null,
    roleList: null,
    userList: null,
    singleUser: null
}